import { ICurrentRecorder } from '@src/types';
import { create } from 'zustand';

interface IRecordingStore {
  onConfirm: () => void;
  onDismiss: () => void;
  currentRecorder: ICurrentRecorder;
  setCurrentRecorder: (data: ICurrentRecorder) => void;
}

export const useRecordingStore = create<IRecordingStore>((set) => ({
  onDismiss: () => {},
  onConfirm: () => {},
  currentRecorder: {
    peer_name: '',
    peer_id: '',
    action: '',
  },
  setCurrentRecorder: (data: ICurrentRecorder) => {
    set((state) => ({
      ...state,
      currentRecorder: data,
    }));
  },
}));
